import React from 'react';
import PropTypes from 'prop-types';

import { IconButton, Tooltip, Trash02Icon } from '@metarouter-private/mr-mui';

import buildDisabledMessage from './buildDisabledMessage';

export default function DeleteTagAction({ row, onDelete }) {
  const disabledMessage = buildDisabledMessage(row);
  const isDisabled = Boolean(disabledMessage);

  return (
    <Tooltip title={disabledMessage ?? ''}>
      <span>
        <IconButton size="small" onClick={onDelete} disabled={isDisabled} data-test-id="deleteTag">
          <Trash02Icon />
        </IconButton>
      </span>
    </Tooltip>
  );
}

DeleteTagAction.propTypes = {
  row: PropTypes.object.isRequired,
  onDelete: PropTypes.func.isRequired,
};
